<template>
  <div
    class="rounded-full border border-outline-variant relative p-1 group overflow-hidden pr-2"
    :class="removable ? 'cursor-pointer' : 'cursor-default'"
    @click="removable && emit('remove', member.id)"
  >
    <div class="flex items-center justify-between gap-1">
      <div class="grid grid-flow-col-dense items-center gap-1">
        <BaseMemberAvatar :member="member" size="24" />
        <p class="text-on-surface-variant text-label-large truncate">
          {{ memberShortName(member) }}
        </p>
      </div>
      <BaseIcon v-if="removable" size="18" class="text-on-surface-variant">close</BaseIcon>
    </div>
    <BaseStateLayer v-if="removable" />
  </div>
</template>
<script lang="ts" setup>
import type { Member } from '@/core/models/member/member'
import { memberShortName } from '@/core/models/member/member-name'
import BaseIcon from '../icon/BaseIcon.vue'
import BaseMemberAvatar from '../avatar/BaseMemberAvatar.vue'
import BaseStateLayer from '../state-layer/BaseStateLayer.vue'

interface Props {
  member: Member
  removable?: boolean
}

withDefaults(defineProps<Props>(), {
  removable: true,
})

const emit = defineEmits<{
  (e: 'remove', organizationMemberId: string): void
}>()
</script>
